// The built-in compliance types. Must stay in sync with
// fixify-server/constants/compliance.js — the server uses the same list to
// decide which records are "custom" (and therefore renameable). Used here as the
// initial store value so the dropdown renders before /compliance/types responds.
export const DEFAULT_COMPLIANCE_TYPES = [
  "Gas Safety (CP12)",
  "Electrical Inspection Condition Report (EICR)",
  "Energy Performance Certificate (EPC)",
  "Property Inspection",
  "Carbon Monoxide Alarm",
  "Fire Risk Assessment",
  "Smoke Alarm Record",
  "HMO License",
  "Building & Contents Insurance",
  "Portable Appliance Testing"
];

export const MAX_COMPLIANCE_TYPE_NAME_LENGTH = 100;

// Names are compared trimmed, whitespace-collapsed and case-insensitively so
// "fire  risk assessment" and "Fire Risk Assessment" are the same type.
export const normalizeComplianceTypeName = (name) =>
  String(name || "")
    .trim()
    .replace(/\s+/g, " ");

export const complianceTypeKey = (name) => normalizeComplianceTypeName(name).toLowerCase();

export const isDefaultComplianceType = (name, defaults = DEFAULT_COMPLIANCE_TYPES) => {
  const key = complianceTypeKey(name);
  return (defaults || []).some((item) => complianceTypeKey(item) === key);
};

// Dashboard status is not a flag anyone sets — a record is active for as long as
// it carries a valid-to date, and clearing the date is how a landlord takes it
// off the dashboard. Mirrors isComplianceActive in the server's
// constants/compliance.js.
export const isComplianceActive = (compliance) => !!compliance?.validTo;
